import React from "react";

const CrossPlatformBenefits = () => {

    const benefits = [
        {
            number: "01",
            title: "Single Codebase",
            desc: "Write once and deploy on Android and iOS, reducing development effort and maintenance costs.",
        },
        {
            number: "02",
            title: "Faster Time To Market",
            desc: "Launch products quicker with shared business logic and reusable components.",
        },
        {
            number: "03",
            title: "Lower Development Cost",
            desc: "One team can build for multiple platforms, significantly reducing project expenses.",
        },
        {
            number: "04",
            title: "Consistent Experience",
            desc: "Maintain a unified design and functionality across all devices and operating systems.",
        },
        {
            number: "05",
            title: "Easy Maintenance",
            desc: "Update one codebase and push improvements to both Android and iOS applications.",
        },
        {
            number: "06",
            title: "Future Ready",
            desc: "Scale faster and adopt new features without rebuilding separate applications.",
        },
    ];

    return (
        <>
            <section className="cpb-section">

                <div className="cpb-glow cpb-glow1"></div>
                <div className="cpb-glow cpb-glow2"></div>

                <div className="cpb-container">

                    <div className="cpb-heading">

                        <span>
                            CROSS PLATFORM BENEFITS
                        </span>

                        <h2>
                            Why Businesses Love
                            <br />
                            <strong>Cross-Platform Apps</strong>
                        </h2>

                        <p style={{ textAlign: "center" }}>
                            Cross-platform development helps businesses reduce
                            costs, accelerate delivery and provide a consistent
                            user experience across Android and iOS.
                        </p>

                    </div>

                    <div className="cpb-timeline">

                        {benefits.map((item, index) => (

                            <div
                                key={index}
                                className={`cpb-item ${index % 2 === 0
                                    ? "left"
                                    : "right"
                                    }`}
                            >

                                <div className="cpb-dot"></div>

                                <div className="cpb-card">

                                    <div className="cpb-number">
                                        {item.number}
                                    </div>

                                    <h3>
                                        {item.title}
                                    </h3>

                                    <p>
                                        {item.desc}
                                    </p>

                                </div>

                            </div>

                        ))}

                    </div>

                </div>

                <style>{`

                .cpb-section{
                    position:relative;
                    overflow:hidden;
                    padding:150px 24px;
                    background:#fff;
                }

                .cpb-container{
                    max-width:1440px;
                    margin:auto;
                    position:relative;
                    z-index:2;
                }

                .cpb-heading{
                    text-align:center;
                    margin-bottom:120px;
                }

                .cpb-heading span{
                    display:inline-block;
                    padding:12px 22px;
                    border-radius:999px;
                    background:rgba(232,33,42,.08);
                    color:#E8212A;
                    font-size:13px;
                    font-weight:700;
                    margin-bottom:25px;
                    letter-spacing:1px;
                }

                .cpb-heading h2{
                    font-size:clamp(52px,7vw,58px);
                    line-height:.95;
                    text-align: center;
                    color:#111;
                    margin-bottom:25px;
                    font-family:'Syne',sans-serif;
                }

                .cpb-heading strong{
                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );
                    -webkit-background-clip:text;
                    -webkit-text-fill-color:transparent;
                }

                .cpb-heading p{
                    max-width:760px;
                    margin:auto;
                    color:#666;
                    line-height:1.9;
                    font-size:18px;
                }

                .cpb-timeline{
                    position:relative;
                }

                .cpb-timeline::before{
                    content:"";
                    position:absolute;
                    left:50%;
                    top:0;
                    width:3px;
                    height:100%;
                    transform:translateX(-50%);
                    background:
                    linear-gradient(
                        #E8212A,
                        #FF4D4D
                    );
                }

                .cpb-item{
                    position:relative;
                    width:50%;
                    margin-bottom:80px;
                }

                .cpb-item.left{
                    padding-right:70px;
                }

                .cpb-item.right{
                    margin-left:auto;
                    padding-left:70px;
                }

                .cpb-dot{
                    position:absolute;
                    top:45px;
                    width:26px;
                    height:26px;
                    border-radius:50%;
                    background:#E8212A;
                    border:6px solid #fff;
                    box-shadow:
                    0 0 0 8px rgba(232,33,42,.12);
                }

                .cpb-item.left .cpb-dot{
                    right:-13px;
                }

                .cpb-item.right .cpb-dot{
                    left:-13px;
                }

                .cpb-card{
                    background:#fff;
                    border:1px solid #eee;
                    border-radius:32px;
                    padding:40px;
                    transition:.4s ease;
                    box-shadow:
                    0 15px 40px rgba(0,0,0,.05);
                }

                .cpb-card:hover{
                    transform:translateY(-10px);
                    box-shadow:
                    0 30px 80px rgba(232,33,42,.12);
                }

                .cpb-number{
                    font-size:64px;
                    line-height:1;
                    font-weight:800;
                    margin-bottom:18px;
                    color:rgb(241 50 58);
                    font-family:'Syne',sans-serif;
                }

                .cpb-card h3{
                    font-size:34px;
                    margin-bottom:15px;
                    color:#111;
                    font-family:'Syne',sans-serif;
                }

                .cpb-card p{
                    color:#666;
                    line-height:1.9;
                    font-size:16px;
                }

                .cpb-glow{
                    position:absolute;
                    border-radius:50%;
                    filter:blur(120px);
                    opacity:.12;
                }

                .cpb-glow1{
                    width:380px;
                    height:380px;
                    background:#E8212A;
                    top:-100px;
                    left:-100px;
                }

                .cpb-glow2{
                    width:350px;
                    height:350px;
                    background:#FF4D4D;
                    right:-100px;
                    bottom:-100px;
                }

                @media(max-width:900px){

                    .cpb-timeline::before{
                        left:25px;
                    }

                    .cpb-item{
                        width:100%;
                        padding-left:70px !important;
                        padding-right:0 !important;
                        margin-left:0 !important;
                    }

                    .cpb-item .cpb-dot{
                        left:12px !important;
                        right:auto !important;
                    }

                    .cpb-heading h2{
                        letter-spacing:-2px;
                    }

                }

                @media(max-width:768px){

                    .cpb-section{
                        padding:100px 18px;
                    }

                    .cpb-card{
                        padding:30px;
                    }

                    .cpb-card h3{
                        font-size:26px;
                    }

                    .cpb-number{
                        font-size:48px;
                    }

                }

            `}</style>

            </section>
        </>
    );
};

export default CrossPlatformBenefits;